import { SetupSignalRConnection } from "../middlewares/signalR.js";
import { MODULE_BASE_PATH } from "../../services/constants";
var BASE_URL = window.SIGNIAPP_API_BASE_URL;
var path = '/NotificationHub';
var connectionHub = MODULE_BASE_PATH.includes('localhost') ? "".concat(MODULE_BASE_PATH).concat(path) : "".concat(BASE_URL).concat(MODULE_BASE_PATH).concat(path);
export var setupEventsHub = SetupSignalRConnection(connectionHub);
export var initFeed = function initFeed() {
  return function (dispatch) {
    dispatch(setupEventsHub);
  };
};
export var stopFeed = function stopFeed() {};
export default {
  initFeed: initFeed
};